import { useAuth0 } from "@auth0/auth0-react";
import { NavLink, Outlet } from "react-router";
import { canSeeSyncHealth, isAdmin } from "../lib/roles";
import { useMe } from "../lib/session";
import { useTheme, type ThemeChoice } from "../lib/theme";
import { Logo } from "./Logo";

const navClass = ({ isActive }: { isActive: boolean }) =>
  `touch-target inline-flex items-center rounded-lg px-3 py-2 font-medium ${isActive ? "bg-surface text-brand" : "text-muted"}`;

export function Shell() {
  const me = useMe();
  const { logout } = useAuth0();
  const [theme, setTheme] = useTheme();

  return (
    <div className="min-h-screen">
      <header className="border-b border-line bg-card">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3">
          <Logo size="text-2xl" />
          <span className="text-sm text-muted">{me.tenant.name}</span>
          <nav aria-label="Main" className="flex flex-wrap gap-1">
            <NavLink to="/" end className={navClass}>Overview</NavLink>
            {canSeeSyncHealth(me) && <NavLink to="/sync-health" className={navClass}>Sync health</NavLink>}
            {isAdmin(me) && <NavLink to="/settings" className={navClass}>Settings</NavLink>}
          </nav>
          <div className="ml-auto flex flex-wrap items-center gap-3">
            <label className="flex items-center gap-2 text-sm text-muted">
              Theme
              <select
                value={theme}
                onChange={(e) => setTheme(e.target.value as ThemeChoice)}
                className="touch-target rounded-lg border border-line bg-card px-2 py-1 text-ink"
              >
                <option value="system">System</option>
                <option value="light">Light</option>
                <option value="dark">Dark</option>
              </select>
            </label>
            <span className="text-sm text-muted" title={me.user.email}>{me.user.name || me.user.email}</span>
            <button
              type="button"
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
              className="touch-target rounded-lg border border-line px-3 py-1.5 text-sm font-medium text-ink"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
